export default "__VITE_ASSET__CkgYwlUq__"